/**
 * Dynamic Backend URL Configuration
 * Automatically detects the current domain and sets the appropriate backend URL
 * Supports: jgmodels.com, preview.emergentagent.com, and localhost
 */

// Function to get the appropriate backend URL based on current hostname
const getBackendURL = () => {
  const hostname = window.location.hostname;
  
  // For custom domain
  if (hostname === 'jgmodels.com') {
    return 'https://jgmodels.com';
  }
  
  // For preview domain
  if (hostname.includes('preview.emergentagent.com')) {
    return `https://${hostname}`;
  }
  
  // For localhost development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8001';
  }
  
  // Fallback to environment variable or current origin
  return process.env.REACT_APP_BACKEND_URL || window.location.origin;
};

export const BACKEND_URL = getBackendURL();

// Log the detected backend URL for debugging
console.log('🔗 Backend URL detected:', BACKEND_URL);
